export default () => {
  String.prototype.ucfirst = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/_start/app/extensions.js